import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-auction-alert',
  templateUrl: './edit-auction-alert.component.html',
  styleUrls: ['./edit-auction-alert.component.scss']
})
export class EditAuctionAlertComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  Auction: FormGroup;
  submitted: boolean = false;
  isLoading: boolean;
  Type: any;
  UserID: any;
  id: any;
  UsersubscriptionMainID: any;
  newdate: string;
  constructor( private route: ActivatedRoute,
    private router: Router,
    private gs: GeneralService,
    private fb: FormBuilder,
    private datepipe: DatePipe) { 
      this.Type = this.route.snapshot.params.UsersubscriptionMainID;
    

    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;

        this.UsersubscriptionMainID = state["UserId"];
        console.log("line=91", this.UserID);
        localStorage.setItem("UserID", state.UserId);
        this.id = state["id"];

        localStorage.setItem("id", state.id);
      } else {
        if (localStorage.getItem("UserID")) {
          this.UserID = localStorage.getItem("UserID");
        }
      }
    }
    }
    
    auc = [];
  ngOnInit() {
    this.breadCrumbItems = [
      {
        label: 'Auction List',
        path: '/franchise/auctionAlert',
      },
      { label: 'Edit Auction', path: '/', active: true },
    ];
    this.newdate = new Date().toISOString().substr(0, 10);

    this.Auction = new FormGroup({
      startDate: new FormControl(null, [Validators.required]),
      endDate: new FormControl(null, [Validators.required]),
      UsersubscriptionMainID: new FormControl(this.route.snapshot.params.UsersubscriptionMainID)
    });

    this.gs
      .getInsertauction(this.route.snapshot.params.UsersubscriptionMainID)
      .subscribe((Response: any) => {
        this.auc = Response.data;

        this.auc.map((item) => {
          item.startDate = this.datepipe.transform(
            item.startDate,
            'yyyy-MM-dd'
          );
          item.endDate = this.datepipe.transform(item.endDate, 'yyyy-MM-dd');
        });
        this.Auction.patchValue(this.auc[0]);
      },
      (error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
  get f() {
    return this.Auction.controls;
  }
  datechange() {
    this.Auction.controls["endDate"].setValue(null);
    var date = new Date(this.Auction.controls.startDate.value);
    this.Auction.controls.endDate.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
add_years(dt,n)
{
  return new Date(dt.setFullYear(dt.getFullYear() + n));      
}
  onSubmit() {
    this.Auction.value;
    this.submitted = true;
    if (this.Auction.valid) {
      // 1 is Property ID
      this.isLoading = true;
      this.gs
        .UpdateAuction(
          this.route.snapshot.params.UsersubscriptionMainID,
          this.Auction.value
        )
        .subscribe((data) => {
          this.isLoading = false;

          if (data.status === 200) {
            this.submitted = false;
            Swal.fire({
              title: 'User Auction Updated',
              text: data.message,
              type: 'success',
            }).then(() => { 
              this.submitted = false;
              // this.reFresh.emit();
              this.router.navigate(['users/auctionAlert']);
            });
          } else {
            Swal.fire({
              title: data.error_code,
              text: data.message,
              type: 'error',
            }).then(() => {
              this.router.navigate(['users/auctionAlert']);
            });
          }
        },
        (error) => {                              //Error callback
          this.isLoading = false;
          Swal.fire({
            title: error.status,
            text: "Internal Server Error",
            type: "error",
          });
          //throw error;   //You can also throw the error to a global error handler
        });
    }
  }
  
}
